import { DataDocument, tagsTemplateDirectoryId } from '@fillip/api';

export const TemplateTagText: DataDocument = {
  id: 'tag-text',
  parentId: tagsTemplateDirectoryId,
  info: {
    title: 'Text',
    icon: 'text',
    isProtected: true,
  },
  element: {
    type: 'element.text',
    textFormat: 'p',
    textContent: ':$text',
  },
  class: {
    class: ':`${$containerClasses}`',
    elementClass: ':`${$elementClasses}`',
  },
  tag: {
    tag: 'tag',
  },
  tagDefinition: {
    tag: 'text',
    title: 'Text',
    category: 'content',
    icon: 'text',
    editor: 'text',
  },
  interfaceDefinition: {
    title: '',
    inheritFrom: 'baseContent',
    props: [
      {
        title: 'Container Classes',
        key: 'containerClasses',
        type: 'string',
        defaultValue:
          ":`${$$contentTagClasses} ${$$textClasses} ${$containerClasses || properties?.containerClasses?.value || ''}`",
      },
      {
        title: 'Element Classes',
        key: 'elementClasses',
        type: 'string',
        defaultValue:
          ":`${$elementClasses || properties?.elementClasses?.value || ''}`",
      },
    ],
  },
};
